import { featureEnabled } from './featureFlagBrowserClient';

const getInternalShowingDetailsUrl = (appointmentId: string) =>
  `/my_business/showing/${appointmentId}`;

export default getInternalShowingDetailsUrl;
